export default {
  lang: 'ar',
  dir: 'rtl',
  common: {
    ok: 'حفظ',
    cancel: 'إلغاء',
    key_backspace: 'مسطرة',
    key_del: 'حذف',
    key_down: 'أسفل',
    key_up: 'أعلى',
    more_opts: 'المزيد من الخيارات',
    url: 'رابط',
    width: 'العرض',
    height: 'الارتفاع'
  },
  misc: {
    powered_by: 'مدعوم بواسطة'
  },
  ui: {
    toggle_stroke_tools: 'إظهار / إخفاء أدوات stroke الإضافية',
    palette_info: 'انقر لتغيير لون التعبئة ، تحولا مزدوجا فوق لتغيير لون السكتة الدماغية',
    zoom_level: 'تغيير مستوى التكبير',
    panel_action: 'انقر لفتح اللوحة الجانبية',
    quality: 'الجودة:',
    pathNodeTooltip: 'اسحب العقدة لنقلها. انقر نقرًا مزدوجًا فوق العقدة لتغيير نوع القطعة.',
    pathCtrlPtTooltip: 'اسحب نقطة التحكم لتعديل خصائص الانحناء',
    pick_stroke_paint_opacity: 'اختر لون stroke وشفافيتها',
    pick_fill_paint_opacity: 'اختر Fill Paint وشفافيتها',
    group_identify_label: 'تسمية تحديد المجموعة',
    export_type_label: 'حدد نوع الصورة للاستخراج:'
  },
  properties: {
    id: 'تحديد العنصر',
    fill_color: 'تغير لون التعبئة',
    stroke_color: 'تغير لون stroke',
    stroke_style: 'تغيير نمط stroke',
    stroke_width: 'تغيير عرض stroke',
    pos_x: 'تغيير إحداثيات X',
    pos_y: 'Change تغيير إحداثيات Y',
    linecap_butt: 'نهاية الخط: مسطحة (بات)',
    linecap_round: 'نهاية الخط: مدورة',
    linecap_square: 'نهاية الخط: مربعة',
    linejoin_bevel: 'نقطة انضمام الخط: المحدبة',
    linejoin_miter: 'نقطة انضمام الخط: الإزاحة',
    linejoin_round: 'نقطة انضمام الخط: مدورة',
    angle: 'تغيير زاوية الدوران',
    blur: 'تغيير قيمة gaussian blur',
    opacity: 'تغيير مختارة غموض البند',
    circle_cx: 'دائرة التغيير لتنسيق cx',
    circle_cy: 'تغيير إحداثيات عنصر دائري (cy)',
    circle_r: 'التغيير في دائرة نصف قطرها',
    ellipse_cx: 'تغيير شكل البيضاوي cx تنسيق',
    ellipse_cy: 'تغيير شكل البيضاوي قبرصي تنسيق',
    ellipse_rx: 'تغيير شكل البيضاوي خ نصف قطرها',
    ellipse_ry: 'تغيير القطع الناقص في دائرة نصف قطرها ذ',
    line_x1: 'تغيير الخط لبدء تنسيق خ',
    line_x2: 'تغيير الخط لانهاء خ تنسيق',
    line_y1: 'تغيير الخط لبدء تنسيق ذ',
    line_y2: 'تغيير الخط لإنهاء تنسيق ذ',
    rect_height: 'تغيير المستطيل الارتفاع',
    rect_width: 'تغيير عرض المستطيل',
    corner_radius: 'تغيير مستطيل ركن الشعاع',
    image_width: 'تغيير صورة العرض',
    image_height: 'تغيير ارتفاع الصورة',
    image_url: 'تغيير العنوان',
    node_x: 'تغيير إحداثيات عقدة X',
    node_y: 'تغيير إحداثيات عقدة Y',
    seg_type: 'تغيير نوع القطعة',
    straight_segments: 'مستقيمة',
    curve_segments: 'منحنية',
    text_contents: 'تغيير محتويات النص',
    font_family_label: 'Font:',
    font_family: 'تغيير الخط الأسرة',
    font_size: 'تغيير حجم الخط',
    bold: 'نص جريء',
    text_decoration_underline: 'تسطير',
    text_decoration_linethrough: 'خط عبر النص',
    text_decoration_overline: 'خط فوق النص',
    italic: 'مائل',
    text_anchor_start: 'محاذاة النص في البداية',
    text_anchor_middle: 'محاذاة النص في الوسط',
    text_anchor_end: 'محاذاة النص في النهاية',
    text_letter_spacing: 'تغيير مسافة الحروف',
    text_word_spacing: 'تغيير مسافة الكلمات',
    text_length: 'يتيح لك تحديد عرض المساحة التي يتم فيها رسم النص',
    text_length_adjust: 'تعديل الطول',
    text_length_adjust_spacing: 'المسافات',
    text_length_adjust_spacing_and_glyphs: 'المسافات والحروف',
    class: 'صنف العنصر',
    serif: 'خط سيريف',
    sans_serif: 'خط سانس سيريف',
    cursive: 'خط كورسيف',
    fantasy: 'خط فانتازيا',
    monospace: 'خط ثابت العرض',
    courier: 'خط كورير',
    helvetica: 'خط هيلفيتيكا',
    times: 'خط تايمز',
    prefs_and_content: 'حفظ التفضيلات ومحتوى SVG محلياً',
    prefs_only: 'حفظ التفضيلات فقط محلياً',
    no_prefs_or_content: 'عدم حفظ تفضيلاتي أو محتوى SVG محلياً',
    jgraduate_pad: 'تعبئة',
    jgraduate_reflect: 'انعكاس',
    jgraduate_repeat: 'تكرار'
  },
  tools: {
    main_menu: 'القائمة الرئيسية',
    bkgnd_color_opac: 'تغيير لون الخلفية / الشفافية',
    connector_no_arrow: 'لا يوجد سهم',
    fitToContent: 'لائقا للمحتوى',
    fit_to_all: 'يصلح لجميع المحتويات',
    fit_to_canvas: 'يصلح لوحة زيتية على قماش',
    fit_to_layer_content: 'يصلح لطبقة المحتوى',
    fit_to_sel: 'يصلح لاختيار',
    align_relative_to: 'محاذاة النسبي ل ...',
    relativeTo: 'بالنسبة إلى:',
    page: 'الصفحة',
    largest_object: 'أكبر كائن',
    selected_objects: 'انتخب الأجسام',
    smallest_object: 'أصغر كائن',
    export_img: 'تصدير الصورة',
    import_doc: 'استيراد SVG',
    align_to_page: 'محاذاة العنصر مع الصفحة',
    align_bottom: 'محاذاة القاع',
    align_center: 'مركز محاذاة',
    align_left: 'محاذاة إلى اليسار',
    align_middle: 'محاذاة الأوسط',
    align_right: 'محاذاة إلى اليمين',
    align_top: 'محاذاة الأعلى',
    mode_select: 'اختر أداة',
    mode_fhpath: 'أداة قلم رصاص',
    mode_line: 'خط أداة',
    mode_rect: 'اداة المستطيل',
    mode_square: 'اداة المربع',
    mode_fhrect: 'اداة المستطيل الحر',
    mode_ellipse: 'القطع الناقص',
    mode_circle: 'دائرة',
    mode_fhellipse: 'اليد الحرة البيضوي',
    mode_path: 'بولي أداة',
    mode_text: 'النص أداة',
    mode_image: 'الصورة أداة',
    mode_zoom: 'أداة تكبير',
    no_embed: 'ملاحظة: لا يمكن تضمين هذه الصورة. ستعتمد على هذا المسار ليتم عرضها.',
    undo: 'التراجع',
    redo: 'إعادته',
    tool_source: 'عدل المصدر',
    wireframe_mode: 'Wireframe وضع',
    clone: 'استنساخ العناصر (s)',
    del: 'حذف العناصر (s)',
    group_elements: 'مجموعة العناصر',
    make_link: 'عمل رابط (فائق) التفاعلية',
    set_link_url: 'تعيين عنوان URL للرابط (اتركه فارغًا للإزالة)',
    to_path: 'تحويل إلى مسار',
    reorient_path: 'إعادة توجيه المسار',
    ungroup: 'إلغاء تجميع العناصر',
    docprops: 'خصائص المستند',
    editor_homepage: 'صفحة SVG-Edit الرئيسية',
    move_bottom: 'الانتقال إلى الأسفل',
    move_top: 'الانتقال إلى الأعلى',
    node_clone: 'استنساخ العقدة',
    node_delete: 'حذف العقدة',
    node_link: 'ربط نقاط التحكم',
    add_subpath: 'إضافة مسار فرعي',
    openclose_path: 'فتح / إغلاق المسار الفرعي',
    source_save: 'حفظ',
    cut: 'قص',
    copy: 'نسخ',
    paste: 'لصق',
    paste_in_place: 'لصق في المكان',
    delete: 'حذف',
    group: 'تجميع',
    move_front: 'إحضار للأمام',
    move_up: 'إحضار للأمام',
    move_down: 'إرسال للخلف',
    move_back: 'إرسال للخلف',
    tool_unlink_use: 'كسر الارتباط مع عنصر الإشارة (جعله فريدًا)',
    ellipse_circle_tool: 'أداة القطع الناقص / الدائرة',
    square_rect_tool: 'أداة المربع / المستطيل',
    remember_this_choice: 'تذكر هذا الخيار؟',
    remember_this_choice_title: 'إذا اخترت الخروج من التخزين أثناء تذكر هذا الخيار ، فسيتغير عنوان URL لتجنب السؤال مرة أخرى.'
  },
  layers: {
    layer: 'طبقة',
    layers: 'الطبقات',
    del: 'حذف الطبقة',
    move_down: 'نقل الطبقة للأسفل',
    new: 'طبقة جديدة',
    rename: 'إعادة تسمية الطبقة',
    move_up: 'نقل الطبقة للأعلى',
    dupe: 'استنساخ الطبقة',
    merge_down: 'دمج للأسفل',
    merge_all: 'دمج الكل',
    move_elems_to: 'نقل العناصر إلى:',
    move_selected: 'نقل العناصر المحددة إلى طبقة مختلفة'
  },
  config: {
    image_props: 'خصائص الصورة',
    doc_title: 'العنوان',
    doc_dims: 'أبعاد الصفحة',
    included_images: 'الصور المدرجة',
    image_opt_embed: 'تضمين البيانات (الملفات المحلية)',
    image_opt_ref: 'استخدم مرجع الملف',
    editor_prefs: 'تفضيلات المحرر',
    language: 'اللغة',
    background: 'خلفية المحرر',
    editor_img_url: 'عنوان URL للصورة',
    editor_bg_note: 'ملاحظة: لن يتم حفظ الخلفية مع الصورة.',
    select_predefined: 'حدد معرف سلفا:',
    units_and_rulers: 'الوحدات والمساطر',
    show_rulers: 'عرض المساطر',
    base_unit: 'وحدة القياس الأساسية:',
    grid: 'شبكة',
    snapping_onoff: 'تشغيل/إيقاف الملتصق',
    snapping_stepsize: 'حجم الخطوة للتلصيق:',
    grid_color: 'لون الشبكة',
    done: 'تم',
    change_xxx_color: 'تغيير لون {{newValue}}',
    pick_paint_opavity: 'اختر {{newValue}} لون الدهان والشفافية',
    open_color_picker: 'انقر لفتح مُنتقِي الألوان',
    jpicker_title: 'اسحب العلامات لاختيار لون',
    jpicker_new_color: 'جديد',
    jpicker_current_color: 'الحالي',
    jpicker_tooltip_colors_new_color: 'لون جديد - اضغط "موافق" للتأكيد',
    jpicker_tooltip_colors_current_color: 'انقر للاستعادة اللون الأصلي',
    jpicker_tooltip_buttons_ok: 'تأكيد اختيار اللون هذا',
    jpicker_tooltip_buttons_cancel: 'إلغاء واستعادة اللون الأصلي',
    jpicker_tooltip_hue_radio: 'ضبط لون "الدرجة"',
    jpicker_tooltip_hue_textbox: 'أدخل قيمة "الدرجة" (0-360 درجة)',
    jpicker_tooltip_saturation_radio: 'ضبط لون "التشبع"',
    jpicker_tooltip_saturation_textbox: 'أدخل قيمة "التشبع" (0-100%)',
    jpicker_tooltip_value_radio: 'ضبط لون "القيمة"',
    jpicker_tooltip_value_textbox: 'أدخل قيمة "القيمة" (0-100%)',
    jpicker_tooltip_red_radio: 'ضبط لون "الأحمر"',
    jpicker_tooltip_red_textbox: 'أدخل قيمة "الأحمر" (0-255)',
    jpicker_tooltip_green_radio: 'ضبط لون "الأخضر"',
    jpicker_tooltip_green_textbox: 'أدخل قيمة "الأخضر" (0-255)',
    jpicker_tooltip_blue_radio: 'ضبط لون "الأزرق"',
    jpicker_tooltip_blue_textbox: 'أدخل قيمة "الأزرق" (0-255)',
    jpicker_tooltip_alpha_radio: 'ضبط لون "الشفافية"',
    jpicker_tooltip_alpha_textbox: 'أدخل قيمة "الشفافية" (0-100)',
    jpicker_tooltip_hex_textbox: 'أدخل قيمة "Hex" اللون (#000000-#ffffff)',
    jpicker_tooltip_hex_alpha: 'أدخل قيمة "الشفافية" ( #00-#ff)',
    jgraduate_solid_color: 'لون صلب',
    jgraduate_linear_gradient: 'تدرج خطي',
    jgraduate_radial_gradient: 'تدرج شعاعي',
    jgraduate_begin_point: 'نقطة البدء',
    jgraduate_enter_starting_x: 'أدخل قيمة الإكس البدء بين 0.0 و 1.0',
    jgraduate_enter_starting_y: 'أدخل قيمة الواي البدء بين 0.0 و 1.0',
    jgraduate_end_point: 'نقطة النهاية',
    jgraduate_enter_ending_x: 'أدخل قيمة الإكس النهائية بين 0.0 و 1.0',
    jgraduate_enter_ending_y: 'أدخل قيمة الواي النهائية بين 0.0 و 1.0',
    jgraduate_center_point: 'نقطة الوسط',
    jgraduate_enter_value_x: 'أدخل قيمة الإكس بين 0.0 و 1.0',
    jgraduate_enter_value_y: 'أدخل قيمة الواي بين 0.0 و 1.0',
    jgraduate_focal_point: 'نقطة التركيز',
    jgraduate_match_center: 'مطابقة الوسط:',
    jgraduate_enter_focal_x: 'أدخل قيمة الإكس التركيز بين 0.0 و 1.0',
    jgraduate_enter_focal_y: 'أدخل قيمة الواي التركيز بين 0.0 و 1.0',
    jgraduate_spread_method: 'طريقة الانتشار',
    jgraduate_radius: 'النصف القطري:',
    jgraduate_set_radius: 'انقر لتحديد النصف القطري',
    jgraduate_ellip: 'الشكل البيضوي:',
    jgraduate_set_ellip: 'انقر لتحديد الشكل البيضوي',
    jgraduate_angle: 'الزاوية:',
    jgraduate_set_angle: 'انقر لتحديد الزاوية',
    jgraduate_deg: 'درجة:',
    jgraduate_opac: 'الشفافية:',
    jgraduate_set_opac: 'انقر لتحديد الشفافية'
  },
  notification: {
    invalidAttrValGiven: 'قيمة غير صالحة',
    noContentToFitTo: 'لا يوجد محتوى مناسب له',
    dupeLayerName: 'هناك طبقة بنفس الاسم بالفعل!',
    enterUniqueLayerName: 'يرجى إدخال اسم طبقة فريد',
    enterNewLayerName: 'يرجى إدخال اسم الطبقة الجديدة',
    layerHasThatName: 'الطبقة تحمل هذا الاسم بالفعل',
    QmoveElemsToLayer: "هل تريد نقل العناصر المحددة إلى الطبقة '%s'؟",
    QwantToClear: 'هل تريد مسح الرسم؟\nسيتم مسح سجل التراجع الخاص بك أيضًا!',
    QwantToOpen: 'هل تريد فتح ملف جديد؟\nسيتم مسح سجل التراجع الخاص بك أيضًا!',
    QerrorsRevertToSource: 'حدثت أخطاء في تحليل مصدر SVG الخاص بك.\nهل تريد العودة إلى مصدر SVG الأصلي؟',
    QignoreSourceChanges: 'تجاهل التغييرات التي تم إجراؤها على مصدر SVG؟',
    featNotSupported: 'الميزة غير مدعومة',
    enterNewImgURL: 'أدخل عنوان URL الجديد للصورة',
    defsFailOnSave: 'ملاحظة: بسبب خلل في المتصفح الخاص بك، قد يظهر هذا الصورة بشكل خاطئ (بدون التدرجات أو العناصر). ولكن سيظهر بشكل صحيح عند حفظه بالفعل.',
    loadingImage: 'جاري تحميل الصورة، يرجى الانتظار...',
    saveFromBrowser: "حدد 'حفظ باسم...' في متصفحك (ربما عبر قائمة الملف أو قائمة سياق النقر بزر الماوس الأيمن) لحفظ هذه الصورة كملف {{type}}.",
    noteTheseIssues: 'يرجى ملاحظة المشاكل التالية أيضًا: ',
    unsavedChanges: 'هناك تغييرات غير محفوظة.',
    enterNewLinkURL: 'أدخل عنوان URL الجديد للارتباط الفائق',
    errorLoadingSVG: 'خطأ: غير قادر على تحميل بيانات SVG',
    URLLoadFail: 'غير قادر على التحميل من عنوان URL',
    retrieving: "جاري استرداد '%s' ...",
    popupWindowBlocked: 'قد يتم حظر نافذة البوب من قبل المتصفح',
    exportNoBlur: 'سيظهر العناصر المضببة كغير مضببة',
    exportNoforeignObject: 'سيظهر عنصر foreignObject بشكل غير صحيح',
    exportNoDashArray: 'سيظهر الخطوط المتقطعة بشكل مملوء',
    exportNoText: 'قد لا يظهر النص على النحو المتوقع',
    editorPreferencesMsg: 'افتراضيًا وحيثما يدعم الأمر، يمكن لـ SVG-Edit تخزين تفضيلات المحرر ومحتوى SVG محليًا على جهازك بحيث لا يلزمك إضافة هذه المحتويات كل مرة تحمل فيها SVG-Edit. إذا لم ترغب لأسباب الخصوصية في تخزين هذه المعلومات على جهازك، فيمكنك التغيير بعيدًا عن الخيار الافتراضي أدناه.',
    source_dialog_note: 'انسخ محتويات هذا الصندوق إلى محرر نصوص، ثم احفظ الملف بامتداد .svg'
  }
}
